module.exports = __webpack_public_path__ + "img/addressEle.84d982a4.svg";